import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
import { atom } from 'jotai';

const warehouseIdForUserAtom = atom(DEFAULT_WAREHOUSE_ID);

export default warehouseIdForUserAtom;
